import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import store from "./store";
import history2 from "./store/history";
import App from "./containers/App/App";
import "./styles/index.css";
import "./i18n";

render(
  <Provider store={store}>
    <ConnectedRouter history={history2}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js